var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"data-label"},[_c('div',{staticClass:"data-label__label text-p-5"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"data-label__value text-p-2"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }